import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { goToCasinoHome, goToPaymentMethods } from '@utils';

import { DepositStep } from '../constants';
import useDeposit from '../deposit/use-deposit';
import Loading from '../loading';
import StatusScreen, { StatusIcon } from '../components/status-screen';
import unavailableIcon from '../assets/method-unavailable@3x.png';
import errorIcon from '../assets/error@3x.png';

const useStyles = makeStyles(() => ({
  app: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minBlockSize: '100dvh',
    backgroundColor: '#1c1c1c'
  }
}));

const App: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { step } = useDeposit();

  useEffect(() => {
    document.title = t('PAYMENT_FORM_LOADING');
  }, [t]);

  if (step === DepositStep.TransactionUnavailable) {
    return (
      <StatusScreen
        headerTitle={t('DEPOSITS.PAGE_TITLE')}
        icon={<StatusIcon src={unavailableIcon} size={100} />}
        title={t('PAYMENT_FORM_UNAVAILABLE_TITLE')}
        text={t('PAYMENT_FORM_UNAVAILABLE_TEXT')}
        buttonLabel={t('PAYMENT_FORM_UNAVAILABLE_BUTTON')}
        onButtonClick={goToPaymentMethods}
        onBack={goToPaymentMethods}
        onClose={goToCasinoHome}
        testId="payment-form-unavailable"
      />
    );
  }

  if (step === DepositStep.Error) {
    return (
      <StatusScreen
        headerTitle={t('DEPOSITS.PAGE_TITLE')}
        icon={<StatusIcon src={errorIcon} size={60} withBackground />}
        title={t('PAYMENT_FORM_ERROR_TITLE')}
        text={t('PAYMENT_FORM_ERROR_TEXT')}
        buttonLabel={t('TRY_AGAIN')}
        onButtonClick={goToPaymentMethods}
        onBack={goToPaymentMethods}
        onClose={goToCasinoHome}
        testId="payment-form-error"
      />
    );
  }

  return (
    <div className={classes.app} data-test-id="payment-form-loading">
      <Loading label={t('PAYMENT_FORM_LOADING')} />
    </div>
  );
};

export default App;
